export default function () {
    return process.env.ENVIRONMENT;
}


// WEBPACK FOOTER //
// ./src/environment.js